import { render, staticRenderFns } from "./login-video.vue?vue&type=template&id=736b6c6e"
import script from "./login-video.vue?vue&type=script&lang=js"
export * from "./login-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports